const state = {
    routeLoading: false
}
const mutations = {
    SET_LOADING: (state, value) => {
        state.routeLoading = value
    },
}
const actions = {
    showLoading({ commit }) {
        commit('SET_LOADING', true)
    },
    hideLoading({ commit }) {
        commit('SET_LOADING', false)
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}